import React, { useState } from 'react';
import axiosInstance from './axiosInstance';
import { useNavigate } from 'react-router-dom';
import './styles/FormStyles.css';  // Add a CSS file to style the form

const Register = () => {
  const [email, setEmail] = useState('');  // Email state first
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosInstance.post('/auth/register', {
        email,   // Send email to the backend first
        username,
        password,
      });

      setMessage('Registration successful! Redirecting to home in 3 seconds...');
      setTimeout(() => {
        navigate('/');  // Redirect to home after 3 seconds
      }, 3000);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setMessage('Username or email already exists.');
      } else {
        setMessage('Error registering user.');
      }
    }
  };

  return (
    <div className="header-div">
      <h2>Register</h2>
    <div className="form-container">
      <form onSubmit={handleRegister}>
        
        <input
          type="email"  // Email input first
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus  // Autofocus on the email field
        />
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Register</button>
      </form>
      <p>{message}</p>
    </div>
    </div>
  );
};

export default Register;
